module.exports = __webpack_public_path__ + "static/media/icon-arrow-back.6b7b0ca7.svg";